export function toTitleCase(string) {
	const tokens = string.split("_")
	let outputString = ""
	tokens.forEach(token => {
		outputString += token.charAt(0).toUpperCase() + token.slice(1).toLowerCase() + " "
	})
	return outputString.slice(0, -1)
}
